import {Moment} from 'moment'

export default class MessageModel {
    constructor(
        public readonly subject: string,
        public readonly body: string,
        public readonly createdAt: Moment
    ) {}
}
